<script>
    import {createEventDispatcher} from 'svelte/internal';
    import {setFocusTo} from "../../lib/lib";
    import AppIcon from "../icons/AppIcon.svelte";

    export let value;
    export let id = '';
    export let disabled = false;
    export let isLocked = true;

    const dispatch = createEventDispatcher();

    const onUnlock = () => {
        isLocked = false;
        if (id) {
            setFocusTo(id);
        }
    }

    const onChange = () => {
        dispatch("change", value);
    }
</script>
<div class="code-control position-relative" class:is-big={ value > 999999 }>
    <input type="text" class="form-control" id="{ id }" bind:value="{ value }"
           oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
           on:change={ onChange }
           autocomplete="off" placeholder="κενό για αυτόματο" readonly="{ isLocked }" disabled="{ disabled }">
    {#if !disabled && isLocked}
        <div class="is-locked" title="ξεκλείδωμα κωδικού" on:click={ onUnlock }>
            <AppIcon icon="lock"/>
        </div>
    {/if}
</div>

<style>
    .is-locked {
        position: absolute;
        top: 50%;
        right: -6px;
        transform: translateY(-50%);
        width: 30px;
        height: 100%;
        display: flex;
        align-items: center;
        color: #f44336;
        cursor: pointer;
    }

    .code-control.is-big .form-control {
        min-width: 90px;
        padding-left: 5px;
        padding-right: 5px;
    }

    .code-control.is-big .is-locked {
        right: -28px;
    }
</style>